import axios from 'axios'
import Vue from 'vue'
import { store } from "../store/index";
import { Notification,MessageBox  } from 'element-ui'
import * as aesUtil from './my-aes'
import QS from 'qs'

let baseUrl = '/'
/*if (process.env.NODE_ENV === 'production') {
  baseUrl = 'https://lxqyes.nmghx.cn/apiPc'
} else if (process.env.NODE_ENV === 'development') {
  //测试环境接口url
  baseUrl = 'https://lxqyes.nmghx.cn/apiPc'
  // baseUrl = 'http://www.mzmblogs.com/apiPc'
  // baseUrl = 'http://lxq.test.com/apiPc'
}*/
const service = axios.create({
  baseURL: `${store.state.domain}/apiPc`,
  /* baseURL: `${store.state.domain}/apiApplet`, */
  headers: {
    get: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    post: {
      'Content-Type': 'application/json;charset=utf-8',
      'Accept': '*/*',
      'Access-Control-Allow-Methods': 'GET,POST,OPTIONS',
      'access-control-allow-origin': '*'
    }
  },
  //响应数据是否需要解密 true：需要，false:不需要
  isAes: true,
  isDeAes: true,
  isFormData: true,
  // 是否跨站点访问控制请求
  withCredentials: false,
  timeout: 30000,
  /*  proxy: {
      host: 'http://lxq.test'
    },*/
  //请求数据转换
  transformRequest: [(data) => {
    //aes 加密
    // data = JSON.stringify(data)
    return data
  }],
  //相应数据转换
  transformResponse: [(data) => {
    //aes  解密
    if (typeof data === 'string' && data.startsWith('{')) {
      data = JSON.parse(data)
    }
    return data
  }]
})

// 请求拦截器
service.interceptors.request.use((config) => {
  if (config.isDeAes) {
    // 请求参数加密
    if (config.method.toLowerCase() === 'post' && config.isFormData) {
      config.params = {}
      config.headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
      config.data = QS.parse(config.data)
      const params = aesUtil.Encrypt(JSON.stringify(config.data), store.state.secretKey)
      
      config.data = QS.stringify({ params })

    } else if (config.method.toLowerCase() === 'get') {
      const params = aesUtil.Encrypt(JSON.stringify(config.params), store.state.secretKey)
    
      config.params = { params }
    }
  }
  return config
}, (error) => {
  // 错误抛到业务代码
  
  error.data = {}
  error.data.msg = '服务器异常，请联系管理员！'
  return Promise.resolve(error)
})

// 响应拦截器
service.interceptors.response.use((response) => {
  const status = response.status
  const code = response.data.code
  let msg = ''
  
  if (status < 200 || status >= 300) {
    // 处理http错误，抛到业务代码
    msg = showStatus(status)
    if (typeof response.data === 'string') {
      response.data = { msg }
    } else {
      response.data.msg = msg
    }
   
    //拦截异常（通知）
   /* Notification({
      title: '提示',
      message: msg,
      type: 'error'
    }) */
  } else {
    // 400 错误
    if (code != 1) {
      //拦截异常（通知）
      console.log('请求超时或服务器异常，请检查网络或联系管理员！')
      if(code==404){
        MessageBox.confirm('数据不存在，点击确定返回上一页', '提示', {
          showCancelButton: false,
          confirmButtonText: '确定',
          type: 'info'
        }).then(()=>{
          window.history.go(-1);
        });
      }
     /* Notification({
        title: '提示',
        message: "请求超时或服务器异常，请检查网络或联系管理员！",
        type: 'error'
      }) */
    }
  }
  //对响应数据解密
  if (response.config.isAes) {
    if (response.data.code === 1) {
      response.data.data = JSON.parse(aesUtil.Decrypt(response.data.data, store.state.secretKey))
    }
  }
  return response.data
}, (error) => {
  // 错误抛到业务代码
  error.data = {}
  error.data.msg = '请求超时或服务器异常，请检查网络或联系管理员！'
  return Promise.resolve(error)
})

const showStatus = (status) => {
  let message = ''
  switch (status) {
    case 400:
      message = '请求错误(400)'
      break
    case 401:
      message = '未授权，请重新登录(401)'
      break
    case 403:
      message = '拒绝访问(403)'
      break
    case 404:
      message = '请求出错(404)'
      break
    case 408:
      message = '请求超时(408)'
      break
    case 500:
      message = '服务器错误(500)'
      break
    case 501:
      message = '服务未实现(501)'
      break
    case 502:
      message = '网络错误(502)'
      break
    case 503:
      message = '服务不可用(503)'
      break
    case 504:
      message = '网络超时(504)'
      break
    case 505:
      message = 'HTTP版本不受支持(505)'
      break
    default:
      message = `连接出错(${status})!`
  }
  return `${message}，请检查网络或联系管理员！`
}

export { service as axios }



// WEBPACK FOOTER //
// ./src/utils/axios.js